import {socialLinks} from './constants';

const LoginFooter = () => {
  return (
    <div className="my-6 mx-6 flex justify-center items-center flex-col font-normal text-xs text-gray-400">
      <div className="text-center pb-2 border-b border-gray-400">
        <span>اگر سوالی دارید میتوانید با</span>
        <span className="font-extrabold"> 09352593515 </span>
        <span> تماس بگیرید.</span>
      </div>

      <div className="flex gap-2 justify-center mt-2">
        {socialLinks.map(({href, iconClass, label}) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noreferrer"
            className="border border-gray-400 rounded-full w-6 h-6 text-center flex justify-center items-center"
            aria-label={label}
          >
            <i
              className={`${iconClass} w-3 h-3 text-center flex justify-center items-center`}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default LoginFooter;
